export default "__VITE_ASSET__SE4U40zm__"